export default "__VITE_ASSET__Ddd$FUhN__"